import React from 'react'
import Moment from 'moment';
import Pagination from '../pagination/pagination';
import { useState } from 'react';
import GeneralPopup from '../shared/GeneralPopup'
import { auth } from '../services/auth';
import Loader from '../shared/Loader';
import SocialLogo from '../shared/SocialLogo';
import { subCategoryService } from '../services/ProductService';
import YoutubeDetails from '../components/social/partial/YoutubeDetails';
import { Helmet } from 'react-helmet';
import { getUserOrders, getOrders } from '../services/orders';
import styles from "../css/orders.module.css"

export default function Orders() {

	let PageSize = 15;
	const [error, setError] = useState("");
	const [currentPage, setCurrentPage] = React.useState(1);
	const [post, setPost] = React.useState(null);
	const isAdmin = auth().isAdmin();
	const user = auth().getUser();
	const token = auth().getToken();
	const [hasError, setHasError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [search, setSearch] = useState("");
	const [searchTmp, setSearchTmp] = useState("");
	const [sendSearch, setSendSearch] = useState("");
	const config = {
		headers: { Authorization: `Bearer ${token}` }
	};

	React.useEffect(() => {
		setIsLoading(true);
		if (isAdmin) {
			getOrders(currentPage, PageSize, search, config)
				.then((response) => {
					setPost(response.data);
					setHasError(false);
				}).catch((error) => {
					setHasError(true);
					setError("Invalid fetching, please try again");
				})
				.finally(() => {
					setIsLoading(false);
				});
		} else {
			getUserOrders(user, currentPage, PageSize, config)
				.then((response) => {
					setPost(response.data);
					setHasError(false);
				}).catch((error) => {
					setHasError(true);
					setError("Invalid fetching, please try again");
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	}, [currentPage, sendSearch]);

	const [showPopup, setPopup] = useState(false);
	const [selectedRow, setSelectedRow] = useState();
	const [title, setTitle] = useState('Order Details');

	const togglePopup = (value) => {
		setPopup(!showPopup);
		setSelectedRow(post ? post?.data[value] : null);
	}

	const backgroundStatusColor = (status) => {
		switch (status) {
			case 1: // Pending
				return "bg-gray-400";
			case 2: //Awaiting Payment
				return "bg-red-400";
			case 3: //In Progress
				return "bg-pink-350";
			case 4: // Canceled
				return "bg-gray-400";
			case 5: // Declined
				return "bg-gray-400";
			case 6: // Refunded
				return "bg-green-450";
			case 7: // Completed
				return "bg-green-450";
			case 8: // Delayed
				return "bg-pink-350";
			case 9: // Partial
				return "bg-green-450";
			case 10: // Processing
				return "bg-pink-350";
			default:
				return "text-black";
		}
	}

	const searchField = () => {
		setSearch(searchTmp);
		setSendSearch(!sendSearch)
		setCurrentPage(1)
	}

	return (
		<section className="flex flex-col my-20 px-3 md:px-5 lg:px-5">
			<Helmet>
				<title>Dailysocialboost | Orders</title>
			</Helmet>
			<h2 className="text-xl font-bold my-5">Order History</h2>
			{isLoading ?
				(<div className="my-5 mx-20 flex flex-row justify-center"> <Loader styles={"w-12 h-12"}></Loader> </div>) :
				hasError ? ((<p className="my-10 text-xl text-red-600">Failed loading, please try again!</p>)) : null}
			<div className="flex flex-row items-center gap-10 py-5">
				<input className={` h-8 w-80 ${styles.ordersSearch} `} type="text" placeholder="Search" autoComplete="off" onChange={e => setSearchTmp(e.target.value)} name="search" id="search" />
				<button className="my-2 px-8 py-2 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all" type="button" onClick={() => searchField()}>Search</button>
			</div>
			{post ? post?.data.length > 0 ? (
				<div className="grid grid-cols-12 gap-1 my-5 border-2 border-gray-50 shadow-md p-2 rounded-xl">
					<div className="font-semibold flex flex-row items-center col-span-2">Order ID</div>
					<div className="font-semibold flex flex-row items-center col-span-2">Status</div>
					<div className="font-semibold flex flex-row items-center col-span-2">Description</div>
					<div className="font-semibold flex flex-row items-center col-span-2">Created</div>
					<div className="font-semibold flex flex-row items-center col-span-2">Amount</div>
					<div className="font-semibold flex flex-row items-center"></div>
					<div className="col-span-12"><hr /></div>
					{post ? post?.data?.map((item, idx) => (
						<React.Fragment key={item?.id}>
							<div className="grid grid-cols-12 col-span-12 gap-1 hover:bg-pink-100 transition-all">
								<div className="flex flex-row items-center col-span-2 font-medium">#{item.orderCode}</div>
								<div className={`flex flex-row items-center col-span-2 text-white text-center place-content-center self-center px-2 rounded-3xl ${backgroundStatusColor(item.orderStatus.id)}`}>{item.orderStatus.name}</div>
								<div className="flex flex-row items-center col-span-2">{item.description}</div>
								<div className="flex flex-row items-center col-span-2">{Moment(item.created).format('YYYY-MM-DD')}</div>
								<div className="flex flex-row items-center col-span-2">${item.amountTotal}</div>
								<div className="flex flex-row items-center col-span-2"><button className="font-semibold" id={idx} onClick={(e) => togglePopup(e.target.id)}>Preview</button></div>
							</div>
						</React.Fragment >
					)) : null}
				</div>
			) : !isLoading ? <div className="self-center">No orders found!</div> : null : (
				!isLoading ? <div className="self-center">No orders yet!</div> : null
			)}
			{showPopup ?
				(
					<GeneralPopup title={title} closePopup={togglePopup}>
						<div className="flex flex-col md:flex-col lg:flex-col justify-center align-center lg:justify-around mt-5 lg:mt-0 gap-5 lg:gap-10">
							<div className="flex flex-col md:flex-col lg:flex-row justify-center align-center lg:justify-around border border-solid border-b-0 border-r-white border-t-0 border-r-0 border-l-0 lg:border-r-2 lg:border-l-2 lg:border-r-gray-200  lg:border-l-gray-200  rounded-3xl pb-2 gap-5 lg:gap-10">
								<div className="flex flex-col items-center border border-solid border-b-gray-350 rounded-3xl shadow-sm px-10 py-5">
									<h2 className={`${styles.ordersHeader}`}>Order details</h2>
									<div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="orderCode">Order Id</label>
										</p>
										<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.orderCode || ""} name="orderCode" id="orderCode" required />
									</div>
									<div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="orderStatusName">Order Status</label>
										</p>
										<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.orderStatus?.name || ""} name="orderStatusName" id="orderStatusName" required />
									</div>

									<div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="description">Description</label>
										</p>
										<textarea className={`h-12 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.description || ""} name="description" id="description" required />
									</div>
									<div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="created">Created</label>
										</p>
										<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={Moment(selectedRow?.created).format('YYYY-MM-DD HH:mm')} name="created" id="created" required />
									</div>

								</div>
								<div className="flex flex-col items-center border border-solid border-b-gray-350 rounded-3xl shadow-sm px-10 py-5">
									<h2 className={`${styles.ordersHeader}`}>Payment details</h2>
									{/* <div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="paymentPaymentComment">Payment Comment</label>
										</p>
										<textarea className="h-12 w-80 bg-gray-100 outline-0 border border-transparent border-b-gray-350" disabled type="text" value={selectedRow?.payment?.paymentComment || ""} name="paymentPaymentComment" id="paymentPaymentComment" required />
									</div> */}
									<div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="payed">Payed</label>
										</p>
										<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.payment?.paymentTime != null ? Moment(selectedRow?.payment?.paymentTime).format('YYYY-MM-DD HH:mm') : "/"} name="payed" id="payed" required />
									</div>
									<div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="coinbase">Service</label>
										</p>
										<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.payment?.coinbase != null ? "Coinbase" : "Funds"} name="service" id="service" required />
									</div>
									<div className="py-2">
										<p>
											<label className="uppercase font-semibold" htmlFor="hostedUrl">URL</label>
										</p>
										<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.payment?.coinbase?.hostedUrl || ""} name="hostedUrl" id="hostedUrl" required />
									</div>
								</div>
							</div>
							<div className="flex flex-col border border-solid border-b-gray-350 rounded-3xl shadow-md">
								<h2 className={`${styles.ordersHeaderBottom} `}>Service details</h2>
								<div className="flex flex-col md:flex-col lg:flex-row justify-center align-center lg:justify-around">
									<div className="flex flex-col items-center ">
										<div className="py-2">
											<p>
												<label className="uppercase font-semibold" htmlFor="itemComment">Service</label>
											</p>
											<div className="flex flex-row items-center">
												<div className={`flex flex-col justify-center items-center`}>
													<SocialLogo serviceType={selectedRow?.order_Items[0].menuItem?.subcategory?.nameOfService} />
												</div>
												<input className={`h-8 w-72 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.order_Items[0]?.menuItem?.name || ""} name="itemComment" id="itemComment" required />
											</div>
										</div>
										<div className="py-2">
											<p>
												<label className="uppercase font-semibold" htmlFor="linkToPage">Link</label>
											</p>
											<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={(subCategoryService(selectedRow?.order_Items[0]?.menuItem?.subcategory?.nameOfService) === "TikTok") ?

												selectedRow?.order_Items[0]?.img64 ?
													selectedRow?.order_Items[0]?.menuItem !== null ? selectedRow?.order_Items[0].menuItem?.subcategory?.linkTo + "@" + selectedRow?.order_Items[0].itemComment + "/video/" + selectedRow?.order_Items[0].linkToPage : null
													: selectedRow?.order_Items[0]?.menuItem !== null ? selectedRow?.order_Items[0].menuItem?.subcategory?.linkTo + "@" + selectedRow?.order_Items[0].itemComment : null

												: selectedRow?.order_Items[0].menuItem?.subcategory?.linkTo + selectedRow?.order_Items[0].linkToPage} name="linkToPage" id="linkToPage" required />
										</div>
										<div className="py-2 flex flex-col items-center">
											{selectedRow?.order_Items[0].img64 ?
												<div className={`flex flex-row justify-center text-center  items-center`}><img className={selectedRow?.order_Items[0].img64 ? "object-cover h-36 w-" : null} src={selectedRow?.order_Items[0].img64} alt={selectedRow?.order_Items[0].name}></img></div>
												:
												<div className={`flex flex-row justify-center text-center  items-center`}>
													{(selectedRow?.order_Items[0].img64 || subCategoryService(selectedRow?.order_Items[0]?.menuItem?.subcategory?.nameOfService) === "Youtube") ?
														<div key={"meta-" + selectedRow?.order_Items[0].id} className="flex flex-row transition-all ">
															{subCategoryService(selectedRow?.order_Items[0]?.menuItem?.subcategory?.nameOfService) === "Youtube" ? (
																<>
																	<div className={`flex flex-row  break-all  h-40   w-96 min-h-full  `}>
																		<YoutubeDetails selectedSubCategory={selectedRow?.order_Items[0]?.imgOriginalLink != undefined ? JSON.parse(selectedRow?.order_Items[0]?.imgOriginalLink)[0] : null} youtube={selectedRow?.order_Items[0]?.imgOriginalLink != undefined ? JSON.parse(selectedRow?.order_Items[0]?.imgOriginalLink)[1] : null}></YoutubeDetails>
																	</div>
																</>

															) : null
															}
														</div> : null}
												</div>}
										</div>
										<div className="py-2">
											<p>
												<label className="uppercase font-semibold" htmlFor="itemComment">Item Comment</label>
											</p>
											<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.order_Items[0]?.itemComment || ""} name="itemComment" id="itemComment" required />
										</div>
									</div>
									<div className="flex flex-col items-center">
										<div className="py-2">
											<p>
												<label className="uppercase font-semibold" htmlFor="quantity">Quantity</label>
											</p>
											<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.order_Items[0]?.quantity || ""} name="quantity" id="quantity" required />
										</div>
										<div className="py-2">
											<p>
												<label className="uppercase font-semibold" htmlFor="amountTotal">Amount Total</label>
											</p>
											<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.amountTotal || ""} name="amountTotal" id="amountTotal" required />
										</div>
										<div className="py-2">
											<p>
												<label className="uppercase font-semibold" htmlFor="discount">Discount</label>
											</p>
											<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.discount || "0"} name="discount" id="discount" required />
										</div>
										<div className="py-2">
											<p>
												<label className="uppercase font-semibold" htmlFor="startCount">StartCount</label>
											</p>
											<input className={`h-8 w-80 ${styles.ordersInput}`} disabled type="text" value={selectedRow?.startCount || "0"} name="startCount" id="startCount" required />
										</div>
									</div>
								</div>
							</div>
						</div>
					</GeneralPopup>)
				:
				null
			}
			<div className="mt-12">
				<Pagination
					className="pagination-bar"
					currentPage={currentPage}
					totalCount={post ? post?.totalRecords : null}
					pageSize={PageSize}
					onPageChange={page => setCurrentPage(page)}
				/>
			</div>
		</section>
	)
}
